import React from "react";
import axios from "axios";
import { Link } from "react-router-dom";

export default class Menu extends React.Component {
  constructor() {
    super();
    this.state = {
      showMenu: false,
      links: []
    };

    this.showMenu = this.showMenu.bind(this);
  }

  componentWillMount() {
    axios
      .get(process.env.REACT_APP_API_URL + "/menu")
      .then(({ data }) => this.setState({ links: data.response }))
      .catch(err => console.log(err));
  }

  showMenu(e) {
    if (e.target.className === "menu_icon") {
      this.setState({ showMenu: !this.state.showMenu });
    } else {
      this.setState({ showMenu: false });
    }
  }

  render() {
    const className = this.state.showMenu
      ? "container_menu"
      : "container_menu_hidden";
    return (
      <div className="header_menu content">
        <Link to={{ pathname: "/" }}>
          <div className="header_biblio" />
        </Link>
        <ul className="header_item">
          {this.state.links.map((item, index) => (
            <li key={index}>
              <a href={item.url}>{item.title}</a>
            </li>
          ))}
        </ul>
        <div onClick={e => this.showMenu(e)} className="menu_icon" />
        <div
          className={className}
          onClick={this.showMenu}
          onTouchMove={this.showMenu}
        >
          <ul className="menu">
            {this.state.links.map((item, index) => (
              <li key={index}>
                <a href={item.url}>{item.title}</a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Menu/Menu.js